import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IAdminProduct, ILoadAdminProduct } from "@shared/interfaces";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { JwtService } from "./jwt.service";

@Injectable()
export class OffersService {

  constructor(
    private http: HttpClient,
    private jwtService: JwtService
  ){
  }

  offersSubject = new Subject();
  deleteOffersSubject = new Subject();
  private editProduct$ = new BehaviorSubject<any>(null);

  private get token() {
    return this.jwtService.getTocken() ?? '';
  }  

  get headers(): HttpHeaders {
    return new HttpHeaders({
      //Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNTJhZmQ2YjdiZjRjNTEyZGMwMzU0ZmMxMWFmOGQ4N2ZmOWRhM2M0ODdkYWQ4YTE5MzUyYTk3YjFjZGRjZjQyYWZmMWM4ZWQwZmQ0MTNjZWMiLCJpYXQiOjE2NTExNDExODguMzI1ODY5LCJuYmYiOjE2NTExNDExODguMzI1ODcxLCJleHAiOjE2ODI2NzcxODguMzIwODIsInN1YiI6IjIiLCJzY29wZXMiOltdfQ.GlCtjQhjWrlnamUFVb68QFavn51IdH0iFCcuK3kT5UgGtjkPftRgvES_S-DCj76w7AhTWP6TQ7r1qKXwV_siuUbPktsctCbTPubayKy3LtiaT59jDg54py7sAjg6e9gws1w64BX6HgCJrvpkK97_fvsrdaeDVGteKR-jOTD7fjsoRfPeqTGDgNaM81JuDDjcQOHfiR3x7P0FJHSx4WB38F3mu-Edz6OwrlnLbAuCHUN1ueC1xjFvUAcTJ49rzJekXhnD-hPJeAOw89f18-MGAw4qPG_OZI7LuxvyO859h-HExWJ3quPZWzbdNWCgGran8JiLMty5jq5gO2LzrLidOwjtjjpCWmT-sTeV5ptKWLac1gaxS8lqDmCJs0khogX59muV2zZR0rEw0O_Ie5JWwuzGU-ofBAIPv0wIm-kGJAadeU6EPLHZN1QHZiVWorxav1LTgtVjmpMIi5GLnehvpLcxhrUaDblLcMmXRumfBQNs0RDyf8_MljOd4T1p3Eg1PKAuWyvOFKPsNAe1cRzJDuYJxIunsC38HWg-AL8iHFY99VM6MHPvySjUNPeK311loEykIuN3nhwVaOHrVtuhJoE432FD-wzNt802DjXPFJfxWTNXfPuZEoUA56S-2i8vKgjIh8PrXKjzG3J0xOkpTacbKyGYnGTxgWDCiznaCuU'
      Authorization: 'Bearer ' + this.token
    });
}

  addOffer(body: FormData, edit:boolean, id?:number) {
    let url = environment.apiUrl + '/operator/productOffer';
    if(edit){
      url = environment.apiUrl + `/operator/productOffer/${id}`;
    }
    return this.http.post(url, body, {headers: this.headers});
  }

  hideOffer(id:number) {
    let url = environment.apiUrl + `/operator/productOfferHide/${id}`;
    return this.http.post(url,{}, {headers: this.headers});
  }

  showOffer(id:number) {
    let url = environment.apiUrl + `/operator/productOfferShow/${id}`;
    return this.http.post(url,{}, {headers: this.headers});
  }

  deleteOffer(id:number) {
    let url = environment.apiUrl + `/operator/productOffer/${id}`;
    return this.http.delete(url, {headers: this.headers});
  }

  getOffers(page = 1, count = 50, tag?: any, subtag?: number){
    let url = environment.apiUrl + `/operator/productOffer?page=${page}&count=${count}${tag?'&tags='+tag:''}${subtag?'&subtags='+subtag:''}`;
    if(tag == undefined || tag == '' && subtag == undefined) {
      url = url + '&withouttags=true';
    }
    
    return this.http.get<ILoadAdminProduct>(url, {headers: this.headers});
  }

  getImg(url:string, name:string){
    return this.http.get(url, {responseType: "blob"})
  }

  changeActiveCounter(body: any, id: number) {
    let url = environment.apiUrl + '/operator/changeProductOfferActiveCounter/' + id;
    return this.http.post(url, body, {headers: this.headers});
  }

  changeTimeDicountEndProduct(body: any, id: number) {
    let url = environment.apiUrl + '/operator/changeTimeDicountEndProduct/' + id;
    return this.http.post(url, body, {headers: this.headers});
  }

  getEditProduct(): Observable<IAdminProduct> {
    return this.editProduct$.asObservable();
  }

  setEditProduct(product: IAdminProduct) {
    this.editProduct$.next(product);
  }

}